import { useEffect, useRef } from 'react';
import type { ButtonHTMLAttributes, PropsWithChildren } from 'react';
export function Button({ busy = false, disabled = false, children, onClick, ...rest }:
  ButtonHTMLAttributes<HTMLButtonElement> & { busy?: boolean }) {
  return <button {...rest} className="button" type="button" aria-disabled={busy || disabled}
    aria-busy={busy} onClick={event => { if (!busy && !disabled) onClick?.(event); }}>
    {busy ? 'Guardando…' : children}
  </button>;
}
export function Card({ children }: PropsWithChildren) { return <div className="card">{children}</div>; }
export function StatusLabel({ marked }: { marked: boolean }) {
  return <span className={`status-label ${marked ? 'complete' : ''}`} data-testid="check-status">{marked ? 'Marcado' : 'No marcado'}</span>;
}
export function ErrorMessage({ children }: PropsWithChildren) {
  return <p className="error" role="alert" id="operation-error">{children}</p>;
}

// Materialization of the existing G3 Dialog/Confirmation contract.
export function Confirmation({ title, message, confirmLabel, onAnswer }: {
  title: string; message: string; confirmLabel: string; onAnswer(answer: boolean): void;
}) {
  const dialog = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const invoker = document.activeElement;
    dialog.current?.showModal();
    return () => { dialog.current?.close(); if (invoker instanceof HTMLElement && invoker.isConnected) invoker.focus(); };
  }, []);
  return <dialog className="dialog" ref={dialog} aria-labelledby="confirmation-title"
    onCancel={event => { event.preventDefault(); onAnswer(false); }}>
    <div className="field-stack"><h2 id="confirmation-title">{title}</h2><p>{message}</p>
      <div className="action-group"><Button autoFocus onClick={() => onAnswer(false)}>Seguir aquí</Button>
        <Button onClick={() => onAnswer(true)}>{confirmLabel}</Button></div>
    </div>
  </dialog>;
}

export function ModuleShell({ title, tabs, active, onSelect, children }: PropsWithChildren<{
  title: string; tabs: readonly string[]; active: string; onSelect(tab: string): void;
}>) {
  return <div className="root-page module-shell"><h1>{title}</h1>
    <div role="tablist" className="module-tabs" aria-label={`Secciones de ${title}`}>
      {tabs.map((tab, index) => <button key={tab} role="tab" id={`module-tab-${index}`}
        aria-selected={tab === active} aria-controls="module-panel" tabIndex={tab === active ? 0 : -1}
        onClick={() => onSelect(tab)} onKeyDown={event => {
          const delta = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
          if (delta) { event.preventDefault();
            document.getElementById(`module-tab-${(index + delta + tabs.length) % tabs.length}`)?.focus();
          }
        }}>{tab}</button>)}
    </div><section id="module-panel" role="tabpanel" aria-labelledby={`module-tab-${tabs.indexOf(active)}`} className="field-stack">{children}</section>
  </div>;
}
